import React, { useState } from "react";
import ProductCard from "../Category/ProductCard";
import Filters from "../Category/Filters";
import Header from "../Header/Header";
import CartPopup from "../Category/CardPopup";
import CardSlider from "../Category/CardSlider"; // Importing CardSlider
import "../Category/ProductPage.css";

const products = [
  {
    id: 1,
    name: "Plant 1",
    category: "Plants",
    price: 20,
    image: "/s1.webp",
    description: "Beautiful indoor plant.",
  },
  {
    id: 2,
    name: "Pot 1",
    category: "Pots",
    price: 15,
    image: "/s2.webp",
    description: "Stylish ceramic pot.",
  },
  {
    id: 3,
    name: "Gardening Tool Set",
    category: "Gardening",
    price: 50,
    image: "/s3.webp",
    description: "Complete gardening tool set.",
  },
  {
    id: 4,
    name: "Seed Packet",
    category: "Seeds",
    price: 5,
    image: "/s1.webp",
    description: "High-quality seeds for your garden.",
  },
  {
    id: 5,
    name: "Flower Bulbs",
    category: "Bulbs",
    price: 10,
    image: "/s2.webp",
    description: "Bright and colorful flower bulbs.",
  },
  {
    id: 6,
    name: "Plant 2",
    category: "Plants",
    price: 25,
    image: "/s3.webp",
    description: "Exotic indoor plant.",
  },
  {
    id: 7,
    name: "Ceramic Pot",
    category: "Pots",
    price: 20,
    image: "/s1.webp",
    description: "Handcrafted ceramic pot.",
  },
  {
    id: 8,
    name: "Gardening Gloves",
    category: "Gardening",
    price: 8,
    image: "/s2.webp",
    description: "Durable gardening gloves.",
  },
  {
    id: 9,
    name: "Vegetable Seeds",
    category: "Seeds",
    price: 6,
    image: "/s3.webp",
    description: "Fresh vegetable seeds.",
  },
  {
    id: 10,
    name: "Tulip Bulbs",
    category: "Bulbs",
    price: 12,
    image: "/s1.webp",
    description: "Bright tulip flower bulbs.",
  },
  {
    id: 11,
    name: "Flower Pot",
    category: "Pots",
    price: 10,
    image: "/s2.webp",
    description: "Bright and colorful flower pots.",
  },
  {
    id: 12,
    name: "Plant 3",
    category: "Plants",
    price: 25,
    image: "/s3.webp",
    description: "Exotic indoor plant.",
  },
];

const ProductPage = () => {
  const [cart, setCart] = useState([]);
  const [popupProduct, setPopupProduct] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState(products);
  const [isCartOpen, setIsCartOpen] = useState(false); // State to manage cart slider visibility

  // Function to toggle cart slider visibility
  const toggleCart = () => {
    setIsCartOpen(!isCartOpen); // Toggle cart visibility
  };

  const addToCart = (product) => {
    const existingItem = cart.find((item) => item.id === product.id);

    if (existingItem) {
      setCart(
        cart.map((item) =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item,
        ),
      );
    } else {
      setCart([...cart, { ...product, quantity: 1 }]);
    }

    setPopupProduct(product); // Show the popup when item is added to cart
  };

  const updateCart = (productId, quantity) => {
    if (quantity < 1) return;

    setCart(
      cart.map((item) =>
        item.id === productId ? { ...item, quantity } : item,
      ),
    );
  };

  const removeFromCart = (productId) => {
    setCart(cart.filter((item) => item.id !== productId));
  };

  const applyFilters = ({ priceRange, selectedCategory }) => {
    setFilteredProducts(
      products.filter(
        (product) =>
          product.price >= priceRange[0] &&
          product.price <= priceRange[1] &&
          (!selectedCategory || product.category === selectedCategory),
      ),
    );
  };

  return (
    <>
      <Header
        cartCount={cart.reduce((total, item) => total + item.quantity, 0)}
        toggleCart={toggleCart} // Passing toggleCart to Header
      />
      <div className="product-page">
        <Filters onApplyFilters={applyFilters} />
        <div className="product-grid">
          {filteredProducts.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              addToCart={addToCart}
            />
          ))}
        </div>
        {popupProduct && (
          <CartPopup
            product={{
              ...popupProduct,
              quantity:
                cart.find((item) => item.id === popupProduct.id)?.quantity || 1,
            }}
            onClose={() => setPopupProduct(null)}
            updateCart={updateCart}
          />
        )}
      </div>

      {/* CardSlider Component (Pass necessary props to manage cart visibility and products inside it) */}
      <CardSlider
        cart={cart}
        onClose={toggleCart} // Close the slider
        updateCart={updateCart}
        removeFromCart={removeFromCart}
        isOpen={isCartOpen} // Controlled visibility of the slider
      />
    </>
  );
};

export default ProductPage;
